import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";
import calculator from "./reducers";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import firebase from "firebase/app";
import "firebase/firestore";

let store = createStore(calculator);
const config = {
  apiKey: "AIzaSyD7EnbAngkm6sXlKmKDvGwOOdO5aBlboBw",
  authDomain: "calculatortest-501a3.firebaseapp.com",
  databaseURL: "https://calculatortest-501a3.firebaseio.com",
  projectId: "calculatortest-501a3",
  storageBucket: "calculatortest-501a3.appspot.com",
  messagingSenderId: "382181205492"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

let db = firebase.firestore();

ReactDOM.render(
  <Provider store={store}><App db={db} /></Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js